/**
 * Chave de API para o YouTube
 */
export const API_KEY: string = import.meta.env.VITE_API_KEY;

/**
 * ID da lista de reprodução do YouTube
 */
export const PLAYLIST_ID: string = import.meta.env.VITE_PLAYLIST_ID;

/**
 * Usuário BOT Twitch
 */
export const TWITCH_USER: string = import.meta.env.VITE_TWITCH_USER;


/**
 * Chave BOT Twitch
 */
export const TWITCH_KEY: string = import.meta.env.VITE_TWITCH_KEY;


/**
 * Tabela dados da Twitch
 */
export const TWITCH_TABLE: string = 'twitch';


